// src/component/PostCard/index.jsx (更新版本)
import React from 'react';
import { Card, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import './index.css';

const { Paragraph } = Typography;

const PostCard = ({ post }) => {
  const { title, excerpt, date, tags, id, author } = post;
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/post/${id}`);
  };

  return (
    <Card 
      hoverable
      className="post-card"
      title={title}
      extra={
        <div style={{ textAlign: 'right' }}>
          <div>{date}</div>
          {author && <div style={{ fontSize: '12px', color: '#666', marginTop: '4px' }}>作者: {author}</div>}
        </div>
      }
      onClick={handleClick}
      style={{ cursor: 'pointer' }}
    >
      <div className="post-card-content">
        <Paragraph ellipsis={{ rows: 3, expandable: true, symbol: 'more' }}>
          {excerpt}
        </Paragraph>
        <div className="post-card-tags">
          {tags && tags.map((tag, index) => (
            <span key={index} className="post-card-tag">{tag}</span>
          ))}
        </div>
      </div>
    </Card>
  );
};

export default PostCard;